var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: _vm.isActive
        ? "justify-content: space-between;padding:0 15px;display: flex;align-items: center;"
        : "display: flex;align-items: center;padding-top: 10px;padding-bottom: 10px;justify-content: center;",
      on: { click: _vm.toggleClick },
    },
    [
      _vm.isActive ? _c("span", [_vm._v("收起")]) : _vm._e(),
      _vm.isActive
        ? _c("img", { attrs: { src: require("@/assets/gaiban/shouqi.png") } })
        : _c("img", { attrs: { src: require("@/assets/gaiban/zhankai.png") } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }